import { createFileRoute } from '@tanstack/react-router'

import { ReviewTaskDetailPage } from '../../../../components/pages/backoffice/review-tasks/review-task-detail-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/review-tasks/$taskId/')({
  component: () => (
    <PermissionChecker requiredPermissions={['reviewTasks.read']}>
      <ReviewTaskDetailPage />
    </PermissionChecker>
  ),
})
